<section class="flex items-center justify-between pt-8">
  <div class="flex justify-start items-center gap-4">
    <span (click)="openMenu()" role="button"
      class="btn-gradient-bg w-10 aspect-square flex justify-center items-center">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="13" fill="none" viewBox="0 0 38 32">
        <path fill="#fff" d="M0 0h38v7H0zM0 13h38v6H0zM0 25h38v7H0z" />
      </svg>
    </span>

    <h2 class="text-white heading-m">{{category}}</h2>
  </div>

  <div class="flex justify-start items-center gap-4 rounded-full">

    <div class="w-[57px] md:w-[160px] lg:w-[240px] h-4 bg-white p-1 rounded-full ">
      <div class="bg-Dark-Navy rounded-full h-full transition-all duration-300"
        attr.style="width: {{gameService.lifeSignal()}}%;">
      </div>
    </div>

    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="24" fill="none" viewBox="0 0 54 50"
      [ngClass]="{'animate-ping': gameService.damagedSignal()}">
      <path fill="url(#a)"
        d="m26.667 49.467-3.867-3.52C9.067 33.493 0 25.253 0 15.2 0 6.96 6.453.533 14.667.533c4.64 0 9.093 2.16 12 5.547 2.906-3.387 7.36-5.547 12-5.547C46.88.533 53.333 6.96 53.333 15.2c0 10.053-9.066 18.293-22.8 30.747l-3.866 3.52Z" />
      <defs>
        <linearGradient id="a" x1="26.667" x2="26.667" y1="8.567" y2="49.467" gradientUnits="userSpaceOnUse">
          <stop stop-color="#FE71FE" />
          <stop offset="1" stop-color="#7199FF" />
        </linearGradient>
      </defs>
    </svg>

  </div>
</section>

<app-menu />